import React, { useMemo, useState, useEffect } from "react";
import "./CasosExito.scss";

const CasosExito = ({
  totalVentas = 2500,
  totalImagenes = 50,
  imageBasePath = "/images/casos-exito/",
}) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = useMemo(() => {
    return Array.from({ length: totalImagenes }, (_, index) => ({
      id: index + 1,
      src: `${imageBasePath}${index + 1}.jpeg`,
      alt: `Caso de éxito ${index + 1}`,
    }));
  }, [totalImagenes, imageBasePath]);

  const loopImages = [...images, ...images];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    document.body.style.overflow = selectedImage ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);

  return (
    <>
      <section className="success-cases">
        <div className="container">
          <div className="success-cases__wrapper">
            <div className="success-cases__content">
              <span className="success-cases__eyebrow">Casos de éxito</span>

              <h2 className="success-cases__title">
                Más de <strong>{totalVentas.toLocaleString("es-MX")}+</strong>{" "}
                ventas respaldan la confianza de nuestros clientes en todo México
              </h2>

              <p className="success-cases__description">
                En <strong>Makinaria DIMA</strong> hemos entregado maquinaria a
                clientes de distintos estados del país, construyendo relaciones
                basadas en atención cercana, resultados reales y equipos que
                cumplen con las necesidades de producción de cada proyecto.
              </p>
            </div>

            <div className="success-cases__side">
              <div className="success-cases__card success-cases__card--main">
                <span className="success-cases__card-label">Confianza real</span>
                <h3>Resultados que hablan por nosotros</h3>
                <p>
                  Nuestro historial de entregas demuestra que no solo vendemos
                  maquinaria: ayudamos a que cada cliente encuentre una solución
                  adecuada para su operación.
                </p>
              </div>

              <div className="success-cases__grid">
                <div className="success-cases__card">
                  <span className="success-cases__mini-title">Atención</span>
                  <h4>Trato cercano y profesional</h4>
                  <p>
                    Acompañamos a cada cliente durante el proceso para brindar
                    claridad y confianza.
                  </p>
                </div>

                <div className="success-cases__card">
                  <span className="success-cases__mini-title">Respaldo</span>
                  <h4>Equipos para distintas necesidades</h4>
                  <p>
                    CNC, tornos, láser, compresores, montacargas y más
                    soluciones industriales.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="success-cases__slider-wrap">
            <div className="success-cases__slider-track">
              {loopImages.map((image, index) => (
                <button
                  type="button"
                  key={`${image.id}-${index}`}
                  className="success-cases__slide"
                  onClick={() => openModal(image)}
                >
                  <img src={image.src} alt={image.alt} loading="lazy" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {selectedImage && (
        <div className="success-cases__modal" onClick={closeModal}>
          <div
            className="success-cases__modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="success-cases__modal-close"
              onClick={closeModal}
            >
              ×
            </button>

            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="success-cases__modal-image"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CasosExito;